export default "__VITE_ASSET__a04001e3__"